import { Draggable } from '@shopify/draggable';

if (Draggable && Draggable.Plugins && Draggable.Plugins.Focusable) {
    delete Draggable.Plugins.Focusable;
}

/**
 * Workaround to allow different distance for touch and mouse.
 * Replace default `Draggable.Sensors.TouchSensor` with it
 *  and add `distanceTouch` option when creating `Draggable` instance
 * @example
 *   draggableInstance = new Draggable([], {
        distance: myMouseDistance,
        distanceTouch: myTouchDistance,
        sensors: [TouchSensorWithDistance],
        exclude: { sensors: [Draggable.Sensors.TouchSensor] }
    });
 */
// eslint-disable-next-line es/no-classes
export class TouchSensorWithDistance extends Draggable.Sensors.TouchSensor {
    /**
     * @constructs TouchSensorWithDelay
     * @param {*} containers
     * @param {Object} options
     * @param {Number} [options.distanceTouch] - custom option
     * @param {Number} [options.distance] - library option, will replace it with the value of our custom option
     */
    constructor(containers, options) {
        options = Object.assign({}, options);
        options.distance = options.distanceTouch;
        super(containers, options);
    }
}

export default Draggable;
